import { render } from "./Home.vue?vue&type=template&id=267b3866&scoped=true&bindings={\"users\":\"setup\"}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=267b3866&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-267b3866"

export default script